var map = {
	"./b-campus-bk.svg": "ec0c",
	"./b-play-bk.svg": "b57a",
	"./banana-bk.svg": "a240",
	"./banana-mobile-bk.svg": "b3ec",
	"./banana-outlet-bk.svg": "5bbf",
	"./bb-bk.svg": "6148",
	"./bkk-bk.svg": "3aff",
	"./com7-bk.svg": "a46e",
	"./e-quip-bk.svg": "d703",
	"./huawei-bk.svg": "eccc",
	"./kkp-bk.svg": "72e5",
	"./oppo-bk.svg": "f8b7",
	"./realme-bk.svg": "4d19",
	"./samsung-bk.svg": "0b27",
	"./studio-7-bk.svg": "95fd",
	"./vivo-bk.svg": "14be",
	"./xiaomi-bk.svg": "7e59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "428d";